import { CountryCode, RegionCode } from '@front-app/services/SharedModels';
import countryRegionData, { Country } from 'country-region-data';
import { SelectBoxChoice } from './SelectBoxModel';

const COUNTRY_CODE_CANADA = 'CA' as CountryCode;
const COUNTRY_CODE_US = 'US' as CountryCode;
export const DEFAULT_COUNTRY_CODE = COUNTRY_CODE_CANADA;
export const EMPTY_COUNTRY = '' as CountryCode;

const REGION_CODE_ALBERTA = 'AB' as RegionCode;
export const DEFAULT_REGION_CODE = REGION_CODE_ALBERTA;
export const EMPTY_REGION = '' as RegionCode;

const REMOVED_COUNTRIES = [
	COUNTRY_CODE_CANADA,
	COUNTRY_CODE_US as CountryCode,
];

export const COUNTRY_OPTIONS: SelectBoxChoice[] = [
	{
		key: COUNTRY_CODE_CANADA,
		label: 'Canada',
	},
	{
		key: COUNTRY_CODE_US,
		label: 'United States of America',
	},
	{
		key: 'quick-search-separator',
		label: '',
		isDivider: true,
	},
].concat(countryRegionData
	.filter(({ countryShortCode }) => !REMOVED_COUNTRIES.includes(countryShortCode as CountryCode))
	.map((val) => ({
		key: val.countryShortCode as CountryCode,
		label: val.countryName,
	})));

export const CODE_TO_COUNTRY: Record<string, Country> = countryRegionData
	.reduce((acc: Record<string, Country>, curr) => {
		acc[curr.countryShortCode] = curr;
		return acc;
	}, { });
